module.exports = __webpack_public_path__ + "img/edifici_amicbici_certified.414ea5e3.svg";